/* istanbul ignore file */
type I18nFile = Record<string, unknown>
type ThemeJsFile = {
  Images: Record<string, string>
}
type ThemeJsonFile = Record<string, string>

// Callers pass the context key as-is (e.g. `./en_v2.json`) — don't prefix it again, the
// lookup is an exact match and `././en_v2.json` silently falls back to the base brand.

//used for i18n
const i18nFilesContext = require.context('../I18n', true, /\.json$/)

export const brandVersionedI18nFiles = (fileName: string): I18nFile | undefined =>
  i18nFilesContext(fileName)

//used for colors
const themeJsonFilesContext = require.context('../Themes/brandVersions', false, /\.json$/)

export const brandVersionedThemeJsons = (fileName: string): ThemeJsonFile | undefined =>
  themeJsonFilesContext(fileName)

//used for images
const themeJsFilesContext = require.context('../Themes/brandVersions', false, /\.js$/)

export const brandVersionedThemeFiles = (fileName: string): ThemeJsFile =>
  themeJsFilesContext(fileName)
